import { bool, customCleanEnv } from "envalid";

interface Env {
    isDevMode: boolean;
}

export const env = customCleanEnv(
    import.meta.env,
    {
        DEV: bool(),
    },
    (inputEnv): Env => ({
        isDevMode: inputEnv.DEV,
    }),
);
